import { render } from "./Education.vue?vue&type=template&id=32e2c9d9&ts=true"
import script from "./Education.vue?vue&type=script&lang=ts"
export * from "./Education.vue?vue&type=script&lang=ts"

import exportComponent from "D:\\Karol\\Documents\\Github\\portfolio\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__